import * as z from "zod";

export const getReturnItemBins = {
  name: "getReturnItemBins" as const,
  input: z.object({ returnId: z.string() }),
  output: z.object({
    binsByItemId: z.record(
      z.string(),
      z.array(z.object({ name: z.string(), quantity: z.number() })),
    ),
  }),
};

export type GetReturnItemBinsOutput = z.infer<typeof getReturnItemBins.output>;
